import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingOverlay } from '@/components/common/LoadingOverlay';
import { useAuth } from '@/contexts/auth';
import { getAdminRouteAccessDecision } from '@/components/admin/layout/adminRouteAccess';

const diagnosticsEnabled =
  import.meta.env.DEV ||
  import.meta.env.VITE_ENABLE_ADMIN_DIAGNOSTICS === 'true';

export const RequireAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, authLoading } = useAuth();
  const location = useLocation();
  const redirectTarget = `${location.pathname}${location.search}`;
  const decision = getAdminRouteAccessDecision({
    pathname: location.pathname,
    authLoading,
    hasCurrentUser: Boolean(currentUser),
    isAdmin: currentUser?.isAdmin === true,
    diagnosticsEnabled,
  });

  if (decision.type === 'loading') {
    return <LoadingOverlay isVisible message="Checking admin access..." />;
  }

  if (decision.type === 'login') {
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectTarget)}`} replace />;
  }

  if (decision.type === 'forbidden') {
    return <Navigate to="/dashboard" replace />;
  }

  if (decision.type === 'diagnostic-disabled') {
    return <Navigate to="/admin/tools" replace />;
  }

  return <>{children}</>;
};

export default RequireAdminRoute;
